const baseurl="https://mapview.api-apx.com/Map_api/v1"


export const GetOrgEndpoint=baseurl+"/FetchOrganization_Details"
export const SubscribeEndpoint=baseurl+"/CreatingNewAddOn"
export const VerifyEndpoint=baseurl+"/Verify_AddOn"
